// La URL firmada del original (`full/`) de una celda, para los paneles que lo muestran
// o lo editan (Mejorar, Expansión, Recortar, Marca de agua) —
// ADR-2026-09-16-las-herramientas-del-lienzo-abren-en-panel.
//
// Casi siempre sale de la caché sin red: `useMiniaturasDelLienzo` firma el `full/` de
// cada celda junto con su `opt/`. Si no está (firma vencida), se pide.

import { useEffect, useState } from 'react';
import { firmarEnLote } from '../../../utils/firmarEnLote';
import { getCachedSignedUrl } from '../../../utils/imageCache';
import type { CeldaParaAccion } from '../accionesDeCelda';

export function useUrlDelOriginal(celda: CeldaParaAccion): string | null {
  const path = celda.datos.fileName ? `${celda.companyId}/full/${celda.datos.fileName}` : null;
  const [url, setUrl] = useState<string | null>(() => (path ? getCachedSignedUrl(path) : null));
  useEffect(() => {
    if (!path || url) return;
    let vivo = true;
    firmarEnLote([path])
      .then((m) => {
        if (vivo) setUrl(m.get(path) ?? null);
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
  }, [path, url]);
  return url;
}
